import React from "react";

const FooterComponent = () => {
	return (
		<div className="text-center py-4 bg-white" id="kt_footer">
			<p className="fs-6 mb-0">
				© {new Date().getFullYear()} Netclues Master. All Rights Reserved.
			</p>
		</div>
	);
};

export default FooterComponent;
